import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import "./Navbar.css";

export default function Navbar() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { name: "Home", path: "/" },
    { name: "The Kalon Method", path: "/kalon-method" },
    { name: "Programs", path: "/programs" },
    { name: "My Journey", path: "/my-journey" },
    { name: "Coaching", path: "/coaching" },
    { name: "Blog", path: "/blog" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <nav className="fixed top-2 left-1/2 -translate-x-1/2 w-[95%] z-[200] px-0 py-0 rounded-2xl shadow-lg navbar-border-container">
      <div className="navbar-gradient-border rounded-2xl relative">
        <div className="navbar-background flex justify-between items-center w-full px-6 md:px-8 py-4">
          
          {/* Brand */}
          <Link to="/" className="no-hover flex items-center gap-2">
            <div className="text-white italic font-bold text-5xl md:text-5xl tracking-wide">
              Kalon Fitness
            </div>
          </Link>

          {/* Desktop Menu */}
          <ul className="hidden md:flex gap-7 text-xl md:text-2xl font-medium text-white">
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`transition-all duration-300 hover:text-gray-300 ${
                    location.pathname === item.path ? "active-link" : ""
                  }`}
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>

          {/* Mobile Button */}
          <button
            className="md:hidden text-white text-3xl"
            onClick={() => setIsOpen(!isOpen)}
          >
            ☰
          </button>
        </div>

        {/* Mobile Dropdown */}
        {isOpen && (
          <ul className="md:hidden bg-black/90 w-full flex flex-col gap-4 text-white px-6 py-4 absolute top-full left-0 z-[500]">
            {menuItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={`block transition-all duration-300 hover:text-neonTurquoise ${
                    location.pathname === item.path ? "active-link" : ""
                  }`}
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        )}
      </div>
    </nav>
  );
}
